import { SingleSolutionCard } from "./singleSolutionCard";
import BookKeeping from "../../../assets/images/business/book keeping.png";
import PaymentLink from "../../../assets/images/business/paymentlinkcard.png";
import VirtualAccount from "../../../assets/images/business/virtual account card.png";
import BulkTransfer from "../../../assets/images/business/bulk transfer.png";
import OnboardingStuff from "../../../assets/images/business/onboardingstuff.png";
import Invoicing from "../../../assets/images/business/invoicing.png";

export const SolutionCards = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <SingleSolutionCard
                imageSrc={BookKeeping}
                title={"Book Keeping"}
                description={" Keep track of cash flow, expenses, and profits effortlessly with smart book keeping "}
            />
            <SingleSolutionCard
                imageSrc={PaymentLink}
                title={"Payment Link"}
                description={" Get paid easily by sharing a secure, custom payment link with customers across the globe.  "}
            />
            <SingleSolutionCard
                imageSrc={VirtualAccount}
                title={"Virtual Account"}
                description={" Make bulk payouts or manage transfers easily through our API or dashboard."}
            />
            <SingleSolutionCard
                imageSrc={BulkTransfer}
                title={"Bulk Transfers"}
                description={" Easily track cash flow, expenses, and profits effortlessly with smart book keeping."}
            />
            <SingleSolutionCard
                imageSrc={OnboardingStuff}
                title={"Onboarding Staff"}
                description={" Easily onboard new team members to view balances, track transactions, and lots more."}
            />
            <SingleSolutionCard
                imageSrc={Invoicing}
                title={"Invoicing"}
                description={" Save time and reduce manual errors by automating invoicing, tracking payments, sending reminders and getting paid quick."}
            />
        </div>
    )
}